import React from "react";
import { Link } from "react-router-dom";
import { LIFE_LOGO } from "@/lib/assets";
import NexWordmark from "@/components/NexWordmark";
import { Mail, MapPin, Phone } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#0A0E17] pt-20 pb-10">
      <div className="w-full mx-auto px-6 md:px-10 lg:px-16 xl:px-24 2xl:px-32">
        <div className="grid lg:grid-cols-12 gap-10 pb-14 border-b border-white/10">
          {/* Lockup */}
          <div className="lg:col-span-5">
            <Link to="/" className="inline-flex items-center gap-5 mb-6">
              <img src={LIFE_LOGO} alt="LIFE LLC" className="h-16 w-16 object-contain" />
              <div className="w-px h-14 bg-nex-border" />
              <div>
                <NexWordmark size="text-3xl" />
                <div className="mono-body text-[10px] tracking-[0.28em] uppercase mt-1">Custom Business Engines</div>
              </div>
            </Link>
            <p className="mono-body text-[12px] leading-relaxed max-w-md">
              A digital infrastructure initiative by the <span className="text-nex-silver">Learning Institute For Empowerment LLC.</span> Established 2023 · Founder: William O. Smith · The Life Foundation.
            </p>
          </div>

          {/* Suite */}
          <div className="lg:col-span-3">
            <div className="mono-label mb-5">// Engine Suite</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/engines" data-testid="footer-flow" className="text-nex-silver hover:text-nex-gold transition-colors">Flow Engine · Trades</Link></li>
              <li><Link to="/engines" data-testid="footer-booking" className="text-nex-silver hover:text-nex-gold transition-colors">Booking Engine · Service</Link></li>
              <li><Link to="/engines" data-testid="footer-capital" className="text-nex-silver hover:text-nex-gold transition-colors">Capital Engine · Retail/B2B</Link></li>
              <li><Link to="/demo" data-testid="footer-demo" className="text-nex-silver hover:text-nex-gold transition-colors">Live Demo</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div className="lg:col-span-2">
            <div className="mono-label mb-5">// Institute</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/program" data-testid="footer-program" className="text-nex-silver hover:text-nex-gold transition-colors">3-Phase Program</Link></li>
              <li><Link to="/case-study" data-testid="footer-case" className="text-nex-silver hover:text-nex-gold transition-colors">Case Study</Link></li>
              <li><Link to="/founder" data-testid="footer-founder" className="text-nex-silver hover:text-nex-gold transition-colors">Founder</Link></li>
              <li><Link to="/pricing" data-testid="footer-pricing" className="text-nex-silver hover:text-nex-gold transition-colors">Pricing</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-2">
            <div className="mono-label mb-5">// Contact</div>
            <ul className="space-y-3 text-sm text-nex-silver">
              <li className="flex items-start gap-2"><Mail size={13} className="text-nex-gold mt-1" /> will.s@nexengines.com</li>
              <li className="flex items-start gap-2"><Phone size={13} className="text-nex-gold mt-1" /> by appointment</li>
              <li className="flex items-start gap-2"><MapPin size={13} className="text-nex-gold mt-1" /> LIFE LLC · United States</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8">
          <p className="mono-body text-[11px]">
            © {new Date().getFullYear()} Learning Institute For Empowerment LLC · NEX™ is a proprietary framework of LIFE LLC.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" data-testid="footer-privacy" className="mono-body text-[10px] uppercase tracking-[0.25em] text-nex-chrome hover:text-nex-gold transition-colors">
              Privacy Policy
            </Link>
            <span className="mono-body text-[10px] uppercase tracking-[0.25em] text-nex-muted">
              Build · Educate · Recycle
            </span>
          </div>
        </div>
      </div>

      <div className="w-full mx-auto px-6 md:px-10 lg:px-16 xl:px-24 2xl:px-32 mt-10">
        <NexWordmark size="text-[120px] md:text-[220px]" className="block leading-none opacity-[0.08] select-none pointer-events-none" />
      </div>
    </footer>
  );
};

export default Footer;
